import { RealtimeInterface } from '../services/realtime/realtime-interface';
import { UserSettings } from '../services/user/user-settings';
import { Role } from './auth/role.class';
import { CustomerProject } from './customer-project.class';
import { Customer } from './customer.class';

export class User implements RealtimeInterface {
    id?: number;
    name: string;
    email: string;
    updated_at?: Date;
    deleted_at?: Date;
    group?: string;
    roles?: Role[];
    function?: string;
    employment_type?: string;
    afas_employee_id?: string;
    zipcode?: string;
    town?: string;
    street?: string;
    housenumber?: string;
    phone?: string;
    profile_picture?: string;
    traveltime_workday: 'Geen' | 'Staffel' | 'Werkelijk';
    default_stand: 'Geen' | 'Thuis' | 'Floridadreef';
    traveltime_weekend: 'Geen' | 'Werkelijk';
    enddate?: Date;
    begindate?: Date;
    contract_hours?: number;

    firstname: string;
    insertion: string;
    lastname: string;

    overtime: boolean;

    maxkm: number;

    hours_checked_by?: number;
    hours_checked_by_role?: string;
    hours_checked_user?: User;
    hours_checked_role?: Role;

    checks_hours?: boolean;
    car_id?: number;
    employees?: User[];
    settings?: UserSettings;
    customers?: Customer[];
    customer_projects?: CustomerProject[];
    customer_projects_history?: CustomerProject[];

    total_login_attempts?: number;
    last_login_attempt?: Date;
    last_login_at?: Date;
}

export enum TraveltimeWorkday {
    Geen = 'Geen',
    Staffel = 'Staffel',
    Werkelijk = 'Werkelijk',
}

export enum TraveltimeWeekend {
    Geen = 'Geen',
    Werkelijk = 'Werkelijk',
}

export enum DefaultStand {
    Geen = 'Geen',
    Home = 'Thuis',
    Floridadreef = 'Floridadreef',
}
